import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import { sanitizeBasicHTML } from 'utils/html';
import { getCookie, setCookie } from 'utils/cookie';
import s from './Notice.module.scss';

const Notice = ({
    richtext = '',
    expireDate = null,
    identifier = '',
}) => {
    const { t } = useTranslation();

    const [mounted, setMounted] = useState(false);
    const [show, setShow] = useState(true);

    // Hash richtext and expire date for creating unique cookie name
    const cookieName = 'sa-notice';

    useEffect(() => {
        setMounted(true);
    }, [])

    useEffect(() => {
        if(show) {
            const currentCookie = getCookie(cookieName);
            if(currentCookie && currentCookie === identifier) {
                setShow(false);
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            }
        }
    }, [show]);

    if(!show) {
        return null;
    }

    const clickHandler = () => {
        setCookie(cookieName, identifier, expireDate);
        setShow(false);
    };

    const sanitizedRichtext = sanitizeBasicHTML(richtext);

    const classes = classNames([
        s['Root'],
        { [s['Root--Open']]: mounted && show },
    ]);

    return (
        <div className={classes} aria-hidden={!show}>
            <div className={s['Root__Wrap']}>
                <div className={s['Root__Icon']}></div>
                <div className={s['Root__Content']}>
                    <div
                        className={s['Root__Richtext']}
                        dangerouslySetInnerHTML={{ __html: sanitizedRichtext }}
                    />
                </div>
                <button
                    type="button"
                    className={s['Root__Close']}
                    aria-label={t('notice.close')}
                    onClick={() => clickHandler()}
                />
            </div>
        </div>
    );
};

Notice.propTypes = {
    richtext: PropTypes.string.isRequired,
    expireDate: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
};

export default Notice;
